import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import {
    getComplianceStandards,
    setActiveCompliance,
    createComplianceStandard,
    resetNewlyCreatedComplianceId,
} from "../store/actions/complianceActions";

import createCompliancRisk from "../store/actions/riskActions";

import TopBar from "../components/TopBar";
import Sidebar from "../components/Sidebar";
import ComplianceSideBar from "../components/ComplianceSideBar";
import ComplianceTopBar from "../components/ComplianceTopBar";
import ComplianceDashboard from "../components/Dashboards/ComplianceDashboard";
import Popup from "reactjs-popup";
import ComplianceOverlay from "../components/Compliance/Overlay";
import "reactjs-popup/dist/index.css";
import { Redirect } from "react-router-dom";
import ComplianceRisk from "../pages/ComplianceRisk";
import ComplianceControl from "./ComplianceControl";
import ComplianceFiles from "../components/Files/ComplianceFiles";
import ComplianceGanttPage from "./ComplianceGanttPage";
import IncidentList from "../components/Incidents/IncidentList";


function CompliancePage(props) {
    const {
        token,
        complianceStandards,
        activeComplianceId,
        newlyCreatedComplianceId,
        getComplianceStandardsFN,
        setActiveComplianceFN,
        createComplianceStandardFN,
        resetNewlyCreatedComplianceIdFN,
    } = props;

    ////console.log("token:", token);

    const [menuitem, setMenuItem] = useState("dashboards");
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [currentCompliance, setCurrentCompliance] = useState(null);
    const [complianceDashboardData, setComplianceDashboardData] = useState(null); // State in the parent

    // Fetch compliance standards on page load
    useEffect(() => {
        getComplianceStandardsFN();
    }, [getComplianceStandardsFN]);

    // Handle new compliance creation
    useEffect(() => {
        if (newlyCreatedComplianceId) {
            const compliance = complianceStandards.find(
                (standard) => standard.compliance_id === newlyCreatedComplianceId
            );
            if (compliance) {
                setCurrentCompliance(compliance);
                setIsPopupOpen(true);
            }
            resetNewlyCreatedComplianceIdFN();
        }
    }, [newlyCreatedComplianceId, complianceStandards, resetNewlyCreatedComplianceIdFN]);

    // useEffect(() => {
    //     if (complianceStandards && complianceStandards?.length > 0) {
    //         setActiveComplianceFN(complianceStandards[0].compliance_id);
    //     }
    // }, [complianceStandards, setActiveComplianceFN]);

    const changeActiveCompliance = (compliance_id) => {
        ////console.log("top level change active compliance:", compliance_id);
        setActiveComplianceFN(compliance_id);
    };

    const handleCreateCompliance = () => {
        createComplianceStandardFN();
    };

    //console.log(menuitem);
//console.log("Active compliance ID in top component: ", activeComplianceId);
    ////console.log("complainceStandards in top component:", complianceStandards);

    return token ? (
        <div className="flex flex-col w-full h-screen overflow-hidden">
            {/* Top Bar */}
            <TopBar className="fixed top-0 left-0 right-0 z-10" />

            {/* Main Content */}
            <div className="flex flex-row w-full h-full">
                {/* Main Sidebar */}
                <Sidebar className="fixed left-0 h-screen z-0" />

                {/* Compliance Sidebar */}
                <ComplianceSideBar
                    complianceStandards={complianceStandards}
                    activeComplianceId={activeComplianceId}
                    setActiveCompliance={changeActiveCompliance}
                    createComplianceStandard={handleCreateCompliance}
                    className="fixed left-0 h-screen z-10 w-[250px] min-w-[250px] max-w-[250px]"
                />

                <div className="flex flex-col w-full">
                    {/* Compliance Top Bar */}
                    <ComplianceTopBar
                        className="w-full h-16 fixed z-10"
                        menuitem={menuitem}
                        setMenuItem={setMenuItem}
                        activeComplianceId={activeComplianceId}
                        complianceStandards={complianceStandards}
                    />

                    {/* Main Content Area */}
                    <div className="flex-grow flex flex-col p-6">
                        {menuitem === "dashboards" ? (
                            <div id="dashboard-content" className="flex flex-col w-full p-4 overflow-auto">
                                <ComplianceDashboard compliance_id={activeComplianceId} setComplianceDashboardData={setComplianceDashboardData}/>
                            </div>
                        ) : menuitem === "risk" ? (
                            <ComplianceRisk activeComplianceStandardId={activeComplianceId}/>
                        ) : menuitem === "files" ? (
                            <ComplianceFiles compliance_id={activeComplianceId}/>
                        ) : menuitem === "controls" ? ( // Add condition for "control"
                           <ComplianceControl activeComplianceId={activeComplianceId}/>
                        ) : menuitem === "actions" ? ( // Add condition for "control"
                            <ComplianceGanttPage activeComplianceId={activeComplianceId} />
                        ) : menuitem === "incidents" ? (
                            <IncidentList activeDepartmentId={activeComplianceId} isCompliance ={true} />
                        ) : (
                            <div> Default Page </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Popup for Compliance Overlay */}
            <Popup
                open={isPopupOpen}
                onClose={() => setIsPopupOpen(false)}
                contentStyle={{ overflow: "auto", maxHeight: "80vh", width: "810px", marginTop: "14vh" }}
            >
                <ComplianceOverlay
                    close={() => setIsPopupOpen(false)}
                    compliance={currentCompliance}
                    edit={true}
                />
            </Popup>
        </div>
    ) : (
        <Redirect to="/login" />
    );
}

const mapStateToProps = (state) => {

    console.log("Data", state.compliance)
    return {
        token: state.auth.token,
        complianceStandards: state.compliance.complianceStandards,
        activeComplianceId: state.compliance.activeComplianceId,
        newlyCreatedComplianceId: state.compliance.newlyCreatedComplianceId,
    }
};

const mapDispatchToProps = (dispatch) => {
    
    return {
        getComplianceStandardsFN: () => dispatch(getComplianceStandards()),
        setActiveComplianceFN: (compliance_id) => dispatch(setActiveCompliance(compliance_id)),
        createComplianceStandardFN: () => dispatch(createComplianceStandard()),
        resetNewlyCreatedComplianceIdFN: () => dispatch(resetNewlyCreatedComplianceId()),
    }
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(CompliancePage);